import { render, staticRenderFns } from "./PrintLetterLabel.vue?vue&type=template&id=1f455480&"
import script from "./PrintLetterLabel.vue?vue&type=script&lang=js&"
export * from "./PrintLetterLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports